import { action } from 'sky-engine/api/index'

import { PERIPHERAL } from '@/api/apiModules'
/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function getPeripheralList(data) {
  return action(PERIPHERAL, 'list', data)
}
